import React from 'react';
import Service from './Service';
import { useTranslation } from 'react-i18next';
import BreadCrumbs from '../common/BreadCrumbs';
import Page from '../common/Page';

const ServicePage = () => {

    const { t } = useTranslation();

    return (
        <Page>
            <BreadCrumbs stack={[
                {title: t("Domů"), path: "/"},
                {title: t("Servis"), path: "/service"}
            ]} />
            <Service />
        </Page>
    );
};

export default ServicePage;